export const CORONA_KFW_QUICK_CREDIT_MAX_LOAN_DURATION = 120;
export const CORONA_KFW_QUICK_CREDIT_MIN_LOAN_DURATION = 24;
export const CORONA_KFW_PROGRAM_LOWER_FINANCING_LIMIT = 800000;
export const CORONA_KFW_PROGRAM_LARGE_FINANCING_MAX_LOAN_DURATION = 72;
export const CORONA_KFW_PROGRAM_SMALL_FINANCING_MAX_LOAN_DURATION = 120;
